import styled, { css } from 'styled-components'
const greenB = css`
  background-color: var(--green);
`
const redB = css`
  background-color: var(--red);
`
export const Wrapper = styled.span`
  .label {
    font-weight: bold;
    padding: 7px 12px;
    border-radius: 5px;
    font-size: var(--smallFont);
  }
`
